module.exports = __webpack_public_path__ + "img/full1-min.f73b7bdb.png";